<template>
    <div class="maps-vue">
        <div class="maps-address">
            {{ fullAddress }},<br>
            {{ city }}
        </div>
        <a class="maps-link" target="_blank" :href="'https://www.google.nl/maps/dir//'+encodeURIComponent(city)+','+encodeURIComponent(address)+' '+encodeURIComponent(number)+'/'">
            Plan route via maps
        </a>
        <img :class="{'maps-map-inactive': !currentLocation.lat}" src="/wp-content/themes/coachfinder/assets/img/maps-placeholder.png" @click="(currentLocation.lat) ? open() : close()">

        <lightbox :is-open="isOpen" @close="close" class="lightbox-full">
            <GmapMap
                ref="mapRef"
                :center="{lat:currentLocation.lat, lng:currentLocation.lng}"
                :zoom="mapOptions.zoom"
                :options="mapOptions"
                map-type-id="terrain"
                class="maps-map"
            >
              <GmapMarker
                :position="{lat:currentLocation.lat, lng:currentLocation.lng}"
                :clickable="false"
                :draggable="true"
              />
            </GmapMap>
        </lightbox>
    </div>
</template>
<script>

// import {gmapApi} from 'vue2-google-maps'

module.exports = {
    props: {
        lat: {
            type: String,
            required: true,
        },
        lng: {
            type: String,
            required: true,
        },
        address: {
            type: String,
            required: true,
        },
        city: {
            type: String,
            required: true,
        },
        number: {
            type: String,
            required: true,
        },
        suffix: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            isOpen: false,
            fullAddress: '',
            currentLocation : { lat : 0, lng : 0},
            mapOptions: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                zoom: 14,
            }
        }
    },
    computed: {
        // google: gmapApi
    },
    methods: {
        open() {
            this.isOpen = true;
            $('body').addClass('lightbox-open');
        },

        close() {
            this.isOpen = false;
            $('body').removeClass('lightbox-open');
        },

        geocodedAddress() {
            var self = this;
            // let geocoder = new google.maps.Geocoder();
            // console.log(geocoder);
        },

        latLng() {
            axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+this.address+"&key="+window.key).then((response) => {
                console.log(response.data.results[0].geometry.location);
            });
        }
    },
    created() {
        this.geocodedAddress()
    },
    mounted() {
        this.currentLocation.lat = parseFloat(this.lat.replace(',', '.'));
        this.currentLocation.lng = parseFloat(this.lng.replace(',', '.'));
        let number = this.number+' '+this.suffix;
        this.fullAddress = this.address+' '+number.trim();
    }
};
</script>